import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { projectsReducer } from '../../store/reducers/projects.reducer.ts';

interface UpdateModalProps {
  isOpen: boolean;
  selectedItemId: number;
  selectedItemName: string;
  selectedItemType: string;
  onClose: () => void;
}

interface UpdateProjectPayload {
  projectId: number;
  newName: string;
}

interface UpdateFolderPayload {
  folderId: number;
  newName: string;
}

const RenameModal: React.FC<UpdateModalProps> = ({
  isOpen,
  selectedItemId,
  selectedItemName,
  selectedItemType,
  onClose,
}) => {
  const { updateProject, updateFolder } = projectsReducer.actions;

  const [newName, setNewName] = useState(selectedItemName);

  const dispatch = useDispatch();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (newName.trim() && selectedItemId) {
      if (selectedItemType === 'project') {
        const payload: UpdateProjectPayload = {
          projectId: selectedItemId,
          newName: newName,
        };

        dispatch(updateProject(payload));
      } else {
        const payload: UpdateFolderPayload = {
          folderId: selectedItemId,
          newName: newName,
        };

        dispatch(updateFolder(payload));
      }

      onClose();
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Escape') {
      event.stopPropagation();
      onClose();
    }
  };

  const handleCancel = () => {
    onClose();
  };

  useEffect(() => {
    if (isOpen) {
      setNewName(selectedItemName || '');
    }
  }, [isOpen, selectedItemName]);

  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center"
        onClick={handleCancel}
        onKeyDown={handleKeyDown}
      >
        <div className="bg-greyP5 rounded-md shadow-xl w-[602px] h-auto p-10" onClick={(e) => e.stopPropagation()}>
          <div className="flex items-center justify-between pb-2 border-b border-greyP4">
            <div className="flex items-center space-x-3">
              <h2 className="text-white text-lg font-medium">Update {selectedItemType} name</h2>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="pt-8 space-y-6">
            <div>
              <input
                type="text"
                id="folderName"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                placeholder="Project name"
                className="w-full px-4 py-3 bg-black border border-black rounded-md text-white placeholder-gray-400 focus:outline-none focus:border-green01 transition-colors duration-200"
                autoFocus
              />
            </div>

            <div className="flex items-center justify-end space-x-4 pt-4">
              <button
                type="button"
                onClick={handleCancel}
                className="px-6 py-2 hover:text-gray-400 text-white border border-white rounded-3xl hover:border-gray-500 transition-colors duration-200"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-6 py-2 bg-white text-black font-medium rounded-3xl hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
              >
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default RenameModal;
